/**
 * Template for creating new exercises
 */
import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { staticsUrl } from '../../config';
import Paper from '@material-ui/core/Paper';
import { showSpinner, hideSpinner } from '../../redux/actions';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      textAlign: 'center',
      color: '#999',
      fontWeight: 400,
    },
    '& p': {
      textAlign: 'center',
      fontWeight: 600,
    },
  },
  pictures: {
    width: 500,
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    margin: '0 auto',
    '& > div': {
      width: '32%',
      paddingBottom: '32%',
      marginBottom: '2%',
      backgroundSize: 'contain',
      cursor: 'pointer',
      borderRadius: 5,
      transition: 'all 0.3s',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      '&:hover': {
        transform: 'scale(1.05)',
      },
    }
  },
  sample: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.main,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

let timeout1 = 0;
let timeout2 = 0;
let timeout3 = 0;
let active = true;

function MatchIt(props) {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [no, setNo] = useState(0);
  const [images, setImages] = useState([]);
  const [finished, setFinished] = useState(false);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const len = exercise.length; // exercise length
  const refs = [];
  refs[0] = useRef();
  refs[1] = useRef();
  refs[2] = useRef();
  refs[3] = useRef();
  refs[4] = useRef();
  refs[5] = useRef();
  refs[6] = useRef();
  refs[7] = useRef();
  refs[8] = useRef();

  useEffect(() => {
    // props.showSpinner('Ładuję ćwiczenie');
    startStats(type);
    // setTimeout(() => {
    initExercise();
    // props.hideSpinner();
    // }, 0)
    // eslint-disable-next-line
    return () => {
      clearTimeout(timeout1)
      clearTimeout(timeout2)
      clearTimeout(timeout3)
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    generateImages();
    // eslint-disable-next-line
  }, [no, data]);

  const initExercise = () => {
    // setData(shuffle(exercise.map((word, idx) => { return { ...word, id: idx, size: getImageSize(word.imageUrl) }})));
    setData(shuffle(exercise.map((word, idx) => { return { ...word, id: idx } })));
    setNo(0);
    setFinished(false);
    active = true;
  }

  const finishTest = () => {
    finishExercise();
    setFinished(true);
    props.media.finish();
  };

  const next = () => {
    action();
    active = false;
    if (no < len - 1) {
      setNo(no + 1);
      active = true;
    } else {
      finishTest();
    }
  }

  const generateImages = () => {
    if (!data.length) return;
    const rawImgSet = [...data];
    rawImgSet.splice(no, 1);
    const shuffled = shuffle(rawImgSet); //.filter(i => i.size !== data[no].size);
    const sliced = shuffled.slice(0, 8);
    sliced.push(data[no]);
    setImages(shuffle(sliced));
  }

  const getDescription = () => {
    return data[no].text;
  }

  const clickHandler = (id, idx) => {
    if (!active) return;
    active = false;
    const result = id === data[no].id;
    const ref = refs[idx].current;
    if (result) {
      props.media.success();
      ref.classList.add('animated', 'pulse');
      timeout1 = setTimeout(() => {
        ref.classList.remove('animated', 'pulse');
        active = true;
        next();
      }, 1000);
    } else {
      const clArr = ['rubberBand', 'shake', 'swing', 'wobble', 'jello'];
      const cl = clArr[Math.floor(Math.random() * 5)];
      props.media.failure();
      ref.classList.add(cl, 'animated');
      timeout1 = setTimeout(() => {
        ref.classList.remove(cl, 'animated');
        active = true;
      }, 1000);
    }
  }

  //   const getImageSize = (imgURL) => {
  //     var request = new XMLHttpRequest();
  //     request.open("HEAD", imgURL, false);
  //     request.send(null);
  //     var headerText = request.getAllResponseHeaders();
  //     var re = /Content-Length\s*:\s*(\d+)/i;
  //     re.exec(headerText);
  //     return parseInt(RegExp.$1);
  // }

  if (!images.length) return '';

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Znajdź obrazek najbardziej pasujący do opisu</h3>
        <div className={classes.pictures}>
          {images.map((img, idx) => <Paper
            ref={refs[idx]}
            key={img.id}
            style={{ backgroundImage: `url("${staticsUrl + img.imageUrl}")` }}
            onClick={() => clickHandler(img.id, idx)}
          />)}
        </div>

        {!finished && <p>{getDescription()}</p>}
        {!finished && <div className={classes.action}>
          <span>{no + 1}/{len} </span>
        </div>}
        {finished && <div className={classes.action} style={{ marginTop: 20 }}>
          <Button variant="outlined" color="secondary" onClick={initExercise}>Zagraj ponownie</Button>
          <Button variant="outlined" color="primary" onClick={close}>Zamknij</Button>
        </div>}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export default connect(mapStateToProps, { showSpinner, hideSpinner })(MatchIt);